import type { ShipId } from './catalog';
import { createMissile } from './createMissile';
import { createSidewinder } from './createSidewinder';
import type * as THREE from 'three';

/** Player missile mesh for the equipped craft (F-22 → AIM-9 Sidewinder). */
export function createPlayerMissile(shipId: ShipId): THREE.Group {
  if (shipId === 'f22') {
    return createSidewinder();
  }
  return createMissile();
}

/** HUD / a11y label for the missile weapon slot. */
export function playerMissileLabel(shipId: ShipId): string {
  if (shipId === 'f22') {
    return 'AIM-9 SIDEWINDER';
  }
  return 'MISSILES';
}

/** True when this craft uses the AIM-9 loadout (mesh + faster lock). */
export function usesSidewinder(shipId: ShipId): boolean {
  return shipId === 'f22';
}

/** HUD label for the secondary rapid-fire weapon slot. */
export function playerSecondaryWeaponLabel(shipId: ShipId): string {
  if (shipId === 'f22') {
    return 'MINIGUN';
  }
  return 'RAILGUN';
}

/** F-22 twin minigun: 2 rounds per trigger pull. */
export function secondaryWeaponAmmoCost(shipId: ShipId): number {
  return shipId === 'f22' ? 2 : 1;
}

/** True when craft fires dual wing barrels (minigun). */
export function usesTwinMinigun(shipId: ShipId): boolean {
  return shipId === 'f22';
}

/** HUD label for countermeasure slot (CHAFF vs FLARES). */
export function playerCountermeasureLabel(shipId: ShipId): string {
  if (shipId === 'f22') {
    return 'FLARES';
  }
  return 'CHAFF';
}

/** True when craft dumps IR flares instead of chaff pods. */
export function usesFlares(shipId: ShipId): boolean {
  return shipId === 'f22';
}
